import { render, staticRenderFns } from "./ReviewPageHeader.vue?vue&type=template&id=6e3f1bdf&scoped=true&"
import script from "./ReviewPageHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPageHeader.vue?vue&type=style&index=0&id=6e3f1bdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f1bdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VSkeletonLoader})
